import { UserDetails } from '@coach-bot/data-access/shared/models';
import { LogLevel } from '@environment/enums/log-level.enum';
import { captureSentryMessage } from '@shared/sentry';
import { ONE_HOUR_MS } from '@shared/utils/constants';
import { Services } from '../services';

const LOAD_USER_DETAILS_INTERVAL_MS = ONE_HOUR_MS;

let loadUserDetailsIntervalId: NodeJS.Timeout | undefined;

/**
 * Updates the Sentry log level based on user details
 */
export function updateSentryLogLevel(services: Services, userDetails: UserDetails | null): void {
  captureSentryMessage(`Updating sentry log level to ${userDetails?.logLevel}`, {
    logLevel: userDetails?.logLevel,
  }, LogLevel.Debug);

  if (userDetails?.logLevel) {
    console.log(`Updating sentry log level to ${userDetails.logLevel}`);
    services.environment.sentryLogLevel = userDetails.logLevel;
  }
}

export async function loadInitialUserDetails(services: Services): Promise<void> {
  let userDetails: UserDetails | null = await services.initialUserDetailsService.getUserDetailsByEmailWithRetry(
    services.commonStore.profileEmail$.value
  );
  captureSentryMessage('User details', userDetails);
  await services.commonStore.setUserDetails(userDetails);

  updateSentryLogLevel(services, userDetails);

  await services.commonStore.setUserDetailsLoaded(true);
}

export function startRefreshingUserDetails(services: Services): void {
  if (!loadUserDetailsIntervalId) {
    // Load user details every hour to make sure any permissions changes are reflected
    loadUserDetailsIntervalId = setInterval(async () => {
      const userDetails: UserDetails | null = await services.initialUserDetailsService.getUserDetailsByEmailWithRetry(
        services.commonStore.profileEmail$.value
      );
      await services.commonStore.setUserDetails(userDetails);

      updateSentryLogLevel(services, userDetails);
    }, LOAD_USER_DETAILS_INTERVAL_MS);

    captureSentryMessage(
      'startRefreshingUserDetails initialized',
      {
        checkingIntervalSeconds: LOAD_USER_DETAILS_INTERVAL_MS,
      },
      LogLevel.Info
    );
  }
}
